import React, {useEffect} from 'react';

import BeersManager from 'features/beersManager/BeersManager';
import {changeModeAC} from 'features/beersManager/slice';
import {beerManagerModes} from 'features/beersManager/typescript';
import {useSetGlobalState} from 'hooks/useSetGlobalState';

import './ManageBeers.scss';

export default function ManageBeers() {
  const dispatch = useSetGlobalState();

  useEffect(() => {
    dispatch(changeModeAC(beerManagerModes.manageBeers));

    return () => {
      dispatch(changeModeAC(beerManagerModes.listBeers));
    };
  }, [dispatch]);

  return (
    <div className="manage-beers" data-testid="manageBeers">
      <BeersManager />
    </div>
  );
}
